import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import {
  IUiSchema,
  IUiSchemaGridFieldRow,
} from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import {
  EElectricityMeterType,
  EElectricityType,
} from "@rentiohq/shared-frontend/dist/types/property.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { JSONSchema6 } from "json-schema";
import { FormValidation } from "react-native-jsonschema-form-test";
import { EField, IExtraData } from "./schema.moveRequestUpdate.types";

const NOW = new Date();

export const getSchema =
  (initialValues: { [key: string]: any }, extraData: IExtraData) =>
  (defaultValues: { [key: string]: any }): JSONSchema6 => {
    const isSingle = () =>
      extraData.moveRequest.electricityType === EElectricityType.Single;
    const isDouble = () =>
      extraData.moveRequest.electricityType === EElectricityType.Double;

    return {
      required: [EField.ElectricityMeterType],
      properties: {
        [EField.ElectricityMeterReadingBoth]: {
          default: getValue(
            EField.ElectricityMeterReadingBoth,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          showIf: isSingle,
          // @ts-ignore
          // requiredIf: isSingle,
        },
        [EField.ElectricityMeterReadingBothDate]: {
          default: getValue(
            EField.ElectricityMeterReadingBothDate,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          showIf: isSingle,
          // @ts-ignore
          // requiredIf: isSingle,
        },
        [EField.ElectricityMeterReadingDay]: {
          default: getValue(
            EField.ElectricityMeterReadingDay,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          showIf: isDouble,
          // @ts-ignore
          // requiredIf: isDouble,
        },
        [EField.ElectricityMeterReadingDayDate]: {
          default: getValue(
            EField.ElectricityMeterReadingDayDate,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          showIf: isDouble,
          // @ts-ignore
          // requiredIf: isDouble,
        },
        [EField.ElectricityMeterReadingNight]: {
          default: getValue(
            EField.ElectricityMeterReadingNight,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          showIf: isDouble,
          // @ts-ignore
          // requiredIf: isDouble,
        },
        [EField.ElectricityMeterReadingNightDate]: {
          default: getValue(
            EField.ElectricityMeterReadingNightDate,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          showIf: isDouble,
          // @ts-ignore
          // requiredIf: isDouble,
        },
        [EField.HandoverDocuments]: {
          default: getValue(
            EField.HandoverDocuments,
            initialValues,
            defaultValues,
          ),
        },
        [EField.ElectricityMeterType]: {
          default: getValue(
            EField.ElectricityMeterType,
            initialValues,
            defaultValues,
          ),
          // @ts-ignore
          options: [
            EElectricityMeterType.Standard,
            EElectricityMeterType.Opening,
            EElectricityMeterType.Budget,
            EElectricityMeterType.Empty,
          ].map(id => ({
            id,
            value: getLocalizedText(
              `move.option.electricity_meter_type.${id}`.toLowerCase(),
            ),
          })),
        },
      },
    };
  };

export const uiSchema = (extraData: IExtraData): IUiSchema<EField> => ({
  "ui:field": ERentioFormField.Grid,
  grid: {
    row: [
      ...(extraData.moveRequest.electricityType === EElectricityType.Single
        ? ([
            {
              col: {
                width: [1, 1 / 2],
                children: [EField.ElectricityMeterReadingBoth],
              },
            },
            {
              col: {
                width: [1, 1 / 2],
                children: [EField.ElectricityMeterReadingBothDate],
              },
            },
          ] as IUiSchemaGridFieldRow[])
        : ([
            {
              col: {
                width: [1, 1 / 2],
                children: [EField.ElectricityMeterReadingDay],
              },
            },
            {
              col: {
                width: [1, 1 / 2],
                children: [EField.ElectricityMeterReadingDayDate],
              },
            },
            {
              col: {
                width: [1, 1 / 2],
                children: [EField.ElectricityMeterReadingNight],
              },
            },
            {
              col: {
                width: [1, 1 / 2],
                children: [EField.ElectricityMeterReadingNightDate],
              },
            },
          ] as IUiSchemaGridFieldRow[])),
      {
        col: {
          width: 1,
          children: [EField.HandoverDocuments],
        },
      },
      {
        col: {
          width: 1,
          children: [EField.ElectricityMeterType],
        },
      },
    ],
  },
  [EField.ElectricityMeterReadingBoth]: {
    "ui:field": ERentioFormField.Number,
    title: getLocalizedText("move.field.electricity_meter_reading_both.title"),
    optional: true,
  },
  [EField.ElectricityMeterReadingBothDate]: {
    "ui:field": ERentioFormField.Date,
    title: getLocalizedText(
      "move.field.electricity_meter_reading_both_date.title",
    ),
    maxDate: NOW,
    // optional: true,
  },
  [EField.ElectricityMeterReadingDay]: {
    "ui:field": ERentioFormField.Number,
    title: getLocalizedText("move.field.electricity_meter_reading_day.title"),
    optional: true,
  },
  [EField.ElectricityMeterReadingDayDate]: {
    "ui:field": ERentioFormField.Date,
    title: getLocalizedText(
      "move.field.electricity_meter_reading_day_date.title",
    ),
    maxDate: NOW,
    // optional: true,
  },
  [EField.ElectricityMeterReadingNight]: {
    "ui:field": ERentioFormField.Number,
    title: getLocalizedText("move.field.electricity_meter_reading_night.title"),
    optional: true,
  },
  [EField.ElectricityMeterReadingNightDate]: {
    "ui:field": ERentioFormField.Date,
    title: getLocalizedText(
      "move.field.electricity_meter_reading_night_date.title",
    ),
    maxDate: NOW,
    // optional: true,
  },
  [EField.HandoverDocuments]: {
    "ui:field": ERentioFormField.DocumentSelectInline,
    title: getLocalizedText("move.field.electricity_handover_documents.title"),
    optional: true,
    multiple: true,
    accept: ["application/*", "image/*"],
  },
  [EField.ElectricityMeterType]: {
    "ui:field": ERentioFormField.InlineSelect,
    title: getLocalizedText("move.field.electricity_meter_type.title"),
  },
});

export const getValidate =
  (_: IExtraData) => (formData: any, errors: FormValidation) => {
    [
      {
        meterReadingKey: EField.ElectricityMeterReadingDay,
        meterReadingDateKey: EField.ElectricityMeterReadingDayDate,
      },
      {
        meterReadingKey: EField.ElectricityMeterReadingNight,
        meterReadingDateKey: EField.ElectricityMeterReadingNightDate,
      },
      {
        meterReadingKey: EField.ElectricityMeterReadingBoth,
        meterReadingDateKey: EField.ElectricityMeterReadingBothDate,
      },
    ].forEach(value => {
      const { meterReadingKey, meterReadingDateKey } = value;

      const meterReading = formData[meterReadingKey] || "";
      const meterReadingDate = formData[meterReadingDateKey] || "";

      if (meterReading === "" && meterReadingDate !== "") {
        errors[meterReadingKey].addError(
          getLocalizedText("move.field.error.meter_reading.required"),
        );
      }

      if (meterReading !== "" && meterReadingDate === "") {
        errors[meterReadingDateKey].addError(
          getLocalizedText("move.field.error.meter_reading_date.required"),
        );
      }
    });

    return errors;
  };
